<template>
    <div class="zoom" :class="size">
        <a :href="post.permalink" target="_blank"
            ><UIImage
                v-bind="($props, $attrs)"
                :class="size"
                :src="post.media_url || post.thumbnail_url"
                :alt="post.caption"
        /></a>
    </div>
</template>

<script>
import { UIImage } from '@dundle/ui/components';
export default {
    components: {
        UIImage,
    },
    props: {
        post: {
            type: Object,
            required: true,
        },
        size: {
            type: String,
            required: false,
            default: 'small',
        },
    },
};
</script>

<style lang="scss" scoped>
.small {
    @media screen and (min-width: 768px) {
        max-height: 200px;
        max-width: 200px;
    }

    @media (min-width: 576px) and (max-width: 768px) {
        max-height: 253px;
        max-width: 253px;
    }
}

.large {
    min-width: 401px;
    max-height: 401px;
    object-fit: cover;
}

img {
    transition: transform 0.5s ease;
}

.zoom {
    margin: 0 1px 1px 0;
    overflow: hidden;

    @media (min-width: 576px) and (max-width: 768px) {
        margin: 0 2px 2px 0;
    }
}

.zoom:hover img {
    transform: scale(1.1);
}
</style>
